// extracted by mini-css-extract-plugin
export default {"wrapper":"aC6J7F","placeholderWrapper":"bC6J7F","placeholderHidden":"cC6J7F"};